import React from 'react';
import i18n from 'i18next';
import { Numbers } from '@weezevent/nacre';
import Rate from './Rate';
import css from '../../../styles.module.css';

export default function Session({ session, form, rates = [] }) {
    const { currency } = form;
    const { language: locale } = i18n;

    const totalAmount = React.useMemo(() => {
        let amount = 0;
        rates.forEach(s_rate => {
            amount += parseFloat(s_rate.price) * s_rate.quantity;
        });
        return amount;
    }, [rates]);

    if (!rates.length > 0) {
        return null;
    }

    return (
        <>
            <div className={css['summary-ticket-item']}>
                <div>{session.text}</div>
                <Numbers className={css['summary-price']} value={totalAmount} locale={locale} currency={currency} showNullDecimal />
            </div>
            <div className={css['summary-ticket-subitem']}>
                {rates.map(rate => (
                    <Rate key={rate.id} rate={rate} form={form} />
                ))}
            </div>
        </>
    );
}
